import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { type Partner, usePutPartnerConnectionMutation } from '../api/partnerApi';
import { PrivacyPolicyCheckbox } from '../formElements/PrivacyPolicyCheckbox';
import { SubmitForm } from '../formElements/SubmitForm';
import { gaLabelsForPartnerClick } from '../gtm/gtmLabels';
import { CustomerCenterLinkWrapper } from './CustomerCenterLink';
import partnerConnection from './images/partner_connection.svg';

interface Props {
    submitRequest: (event: React.FormEvent<HTMLElement>) => void;
    partner: Partner;
}

export const PartnerRequestFormContent = ({ submitRequest, partner }: Props) => {
    const { partnerName, partnerDisplayName, privacyPolicyUrl } = partner;
    const { isLoading: isSubmitting } = usePutPartnerConnectionMutation()[1];

    return (
        <div className='container-fluid fluid-small'>
            <form onSubmit={submitRequest}>
                <div className='text-center'>
                    <h1 className='margin-bottom-5pct'>{partnerDisplayName}</h1>
                </div>
                <div className='display-flex justify-content-center'>
                    <img
                        className={'margin-top-25 margin-bottom-25 img-responsive max-width-600'}
                        src={partnerConnection}
                        alt={'partner-connection'}
                    />
                </div>
                <div className='gap-5 display-flex flex-column align-items-center margin-bottom-5pct margin-top-2pct text-center text-size-18'>
                    <div>
                        <FormattedMessage id={'contactForm.partner.disclaimerDataEnabling'} />
                    </div>
                    <div>
                        <FormattedMessage id={'contactForm.partner.disclaimerWaiting'} />
                    </div>
                    <div>
                        <FormattedMessage
                            id={'contactForm.partner.disclaimerDeleteConnection'}
                            values={{
                                link: chunks => <CustomerCenterLinkWrapper>{chunks}</CustomerCenterLinkWrapper>,
                            }}
                        />
                    </div>
                </div>
                <div className='row'>
                    <SubmitForm
                        isSending={isSubmitting}
                        label={'contactForm.connectPartner'}
                        gaTrackingOnSend={gaLabelsForPartnerClick(partnerName)}
                        iconClass={'uikit-icon icon-compare'}
                    >
                        <PrivacyPolicyCheckbox
                            privacyPolicyUrl={privacyPolicyUrl}
                            checkBoxLabel={'contactForm.privacyPolicy'}
                        />
                    </SubmitForm>
                </div>
            </form>
        </div>
    );
};
